module.exports = __webpack_public_path__ + "static/media/15b-02_Serie-blanca-2-2015-200x300cm-oleo-sobre-papel.15480fc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15b/15b-02_Serie-blanca-2-2015-200x300cm-oleo-sobre-papel.jpg
// module id = 159
// module chunks = 0